import { ConfigState, Filter } from "../types/config";

type State = {
  configState: ConfigState;
};

const getSelectedFilter = ({ configState }: State): string =>
  configState?.selectedFilter || "all";

const getFilters = ({ configState }: State): Filter[] =>
  configState?.config?.tposFilters || [];

const getEnableAsyncFlowForTpos = ({ configState }: State): boolean =>
  Boolean(configState?.config?.featureFlags?.enableAsyncFlowForTpos);

const getEnableCombosForTpos = ({ configState }: State): boolean =>
  Boolean(configState?.config?.featureFlags?.enableCombosForTpos);

const getEnablePickupInDriveThru = ({ configState }: State): boolean =>
  Boolean(configState?.config?.featureFlags?.enablePickupInDriveThru);

const getConfig = ({ configState }: State): State["configState"]["config"] =>
  configState?.config;

export {
  getSelectedFilter,
  getFilters,
  getEnableAsyncFlowForTpos,
  getEnableCombosForTpos,
  getEnablePickupInDriveThru,
  getConfig,
};
